import { Component, input, model, ViewChild } from '@angular/core';
import { UserModel } from '../../../../core/models/data/user.model';
import { UserMembershipListComponent } from '../user-membership-list/user-membership-list.component';
import { CommonModule } from '@angular/common';
import { UserMembershipModel } from '../../../../core/models/ui/user-membership.model';
import { UpdateUserComponent } from '../update-user/update-user.component';

@Component({
  selector: 'ms-user-overview',
  imports: [
    CommonModule,
    UpdateUserComponent,
    UserMembershipListComponent
  ],
  templateUrl: './user-profile-overview.component.html'
})
export class UserProfileOverviewComponent {
  public user = model<UserModel | undefined>(undefined);
  public organizationMemberships = input<UserMembershipModel[]>([]);

  @ViewChild(UpdateUserComponent) updateUserRef!: UpdateUserComponent;

  public openUpdateUserModal(): void {
    this.updateUserRef?.openUpdateUserModal();
  }
}
